import { Routes } from '@angular/router';
import { AuthGuard } from '../core/security/auth-guard.service';
import { RolesEnum } from '../core/security/roles.enum';
import { ModulesEnum } from '../core/security/modules.enum';
import { MenuGroupEnum } from '../core/security/menu-group.enum';
import { SummaryComponent } from './summary/summary.component';

export const routes: Routes = [
  {
    path: 'summary',
    component: SummaryComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SoftPhoneGroup,
      package: ModulesEnum.BasicSoftPhoneModule,
      permissions: [RolesEnum.BasicSoftPhoneView, RolesEnum.BasicSoftPhoneEdit, RolesEnum.BasicSoftPhoneDelete],
      animation: 'main',
      meta: {
        title: 'TeleGo App',
        override: true,
        description: 'TeleGo App Information',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'phone_android',
      },
    },
  },
];
